/**
 * アクセス拒否画面
 */

import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/hooks/use-auth";

export function AccessDeniedScreen() {
  const { user, logout } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <ShieldAlert className="mx-auto h-12 w-12 text-destructive" />
          <CardTitle className="mt-4">アクセス権限がありません</CardTitle>
          <CardDescription>
            このページは管理者のみアクセスできます。
            <br />
            管理者権限をお持ちの場合は、管理者アカウントでログインしてください。
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg bg-muted p-3 text-sm">
            <p className="font-medium">{user?.name}</p>
            <p className="text-muted-foreground">{user?.email}</p>
          </div>
          <Button variant="outline" className="w-full" onClick={logout}>
            ログアウト
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
